import { render, staticRenderFns } from "./BenefitsClub.vue?vue&type=template&id=1d6040c0&scoped=true"
import script from "./BenefitsClub.vue?vue&type=script&lang=js"
export * from "./BenefitsClub.vue?vue&type=script&lang=js"
import style0 from "./BenefitsClub.vue?vue&type=style&index=0&id=1d6040c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6040c0",
  null
  
)

export default component.exports